<script>
import { Doughnut } from 'vue3-chart-v2'

export default {
  extends: Doughnut,
  props: ['part'],
  mounted () {
    this.renderChart({
      labels: ['Expired', 'Complete'],
      datasets: [
        {
            backgroundColor: [
                'rgba(231, 76, 60, 1)',
                'rgba(123, 239, 178, 1)',
            ],
            borderColor: [
                'rgba(207, 0, 15, 1)',
                'rgba(77, 175, 124, 1)',
            ],

          data: [this.part,100 - this.part]
        }
      ]
    },{
        maintainAspectRatio:false

    })
  }
}

</script>